module.exports = __webpack_public_path__ + "static/media/Apartment-5@2x.ba0f75a6.png";